export default function JoinCta() {
  return (
    <section id="join" className="anchor-offset">
      <div className="mx-auto max-w-content px-4 pb-14 md:px-6 md:pb-20">
        <div className="relative overflow-hidden rounded-lg">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20abstract%20sunset%20landscape%20with%20soft%20rolling%20hills%20and%20a%20calm%20sea%2C%20coral%20rose%20and%20golden%20amber%20gradient%20sky%2C%20minimal%20editorial%20illustration%20style%2C%20smooth%20organic%20shapes%2C%20gentle%20romantic%20atmosphere%2C%20no%20text&width=1600&height=800&seq=love-island-cta-2026&orientation=landscape&alt=%E7%88%B1%E6%83%85%E5%B2%9B%E5%90%8C%E5%9F%8E%E4%BA%A4%E5%8F%8B%E7%A4%BE%E5%8C%BA%E6%B0%9B%E5%9B%B4%E7%A4%BA%E6%84%8F%E5%9B%BE"
            alt="爱情岛同城交友社区温馨氛围插图"
            className="h-[320px] w-full object-top md:h-[400px]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/40 to-foreground-950/10" aria-hidden="true"></div>
          <div className="absolute inset-0 flex flex-col items-start justify-end gap-4 p-6 md:p-10">
            <h2 className="max-w-2xl font-heading text-2xl text-background-50 md:text-4xl">
              今天就认识一座城市里，和你同频的单身男女
            </h2>
            <p className="max-w-xl text-sm leading-relaxed text-background-100 md:text-base">
              浏览同城交友圈、加入单身群、进聊天室聊几句，都是免费的。缘分不一定来得快，但它值得一次认真的尝试。
            </p>
            <div className="flex flex-col gap-3 sm:flex-row">
              <a
                href="#cities"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-compass-3-line" aria-hidden="true"></i>
                进入同城交友圈
              </a>
              <a
                href="#chatrooms"
                className="inline-flex items-center justify-center gap-2 rounded-md border border-background-100/60 bg-background-50/10 px-5 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-chat-smile-2-line" aria-hidden="true"></i>
                先去聊天室看看
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}